import(/* webpackMode: "eager" */ "/app/packages/web/src/app/global-error.tsx");
